// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import AccommodationsPage from "../pages/Accommodations/Accommodations";
const __wvcRoutePaths = ["/AccommodationsPage", "/accompagnements"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["a-propos", "aboutpage", "accommodationspage", "accompagnements", "accueil", "batch-cooking", "batchcookingpage", "circlepage", "contact", "contactpage", "homepage", "le-cercle", "nesting-party", "nestingpartypage", "post"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<AccommodationsPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<AccommodationsPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
